export default "__VITE_ASSET__f5791d05__"